//eslint-disable-next-line
import {default as axios} from "./axiosConfig";
import config, { axiosConfig } from "../config";
import { MtplQuotation, Quotation, TravelQuotation } from "../model/quotation";
import { QuoationPackage, TravelQuotationPackage } from "../model/quoationPackage";
import { showNoProductPage } from "../pages/MessagePage";
import * as log from '../utils/log';
import { getFuncMod } from "../utils/log";
import { ProductType } from "./model/common";
import { getTypePath } from "./common";
import { getGA } from '../utils/getGA';
import { getSavedUTM } from '../utils/utm';

export interface ErrorResponse {
    status: string;
    text: string;
    detailText: string;
    redirectUrl?: string;
}

export interface Response {
    success: boolean;
    status?: string;
    data?: any
    errorResponse?: ErrorResponse;
}

export async function getQuotation(quotationId: string, type: ProductType) {
    const { data } = await axios.get<any>(`${config.API_URL}/${getTypePath(type)}/quotation/${quotationId}`, axiosConfig);
    return data;
}

const getUtmMarks = (contitueParams: boolean) => {
    const searchParams = new URLSearchParams(window.location.search)
    let utm: Record<string, string> = {};
    searchParams.forEach((value, key) => {
        if (key.startsWith('utm_')) utm[key] = value;
    });
    if (Object.keys(utm).length === 0) {
        utm = getSavedUTM();
    }
    const result = Object.keys(utm)
        .map(key => key + '=' + encodeURIComponent(utm[key]))
        .join('&');
    const resultString = (contitueParams ? '&' : '?') + result;
    return result ? resultString : '';
}

export async function newQuotation(salesVariant, scenarioCode, type: ProductType) {
    const date = new Date();
    let data: any;
    const params = await getGA
    await axios.post<MtplQuotation | TravelQuotation>(
        `${config.API_URL}/${getTypePath(type)}/init-quotation?scenarioCode=${scenarioCode}&salesVariant=${salesVariant}${getUtmMarks(true)}&user_id=${params.user_id}&session_id=${params.session_id}&client_id=${params.client_id}`,
        {}, axiosConfig)
        .then(response => {
            data = response.data
            log.sendLog(date, getFuncMod(type), 'INFO', "NEW_QUOTATION", [{ quotation: response, salesVariant: salesVariant, scenarioCode: scenarioCode }], '');
        })
        .catch(error => {
            if (error?.response?.status && error.response.status === 423) {
                showNoProductPage();
                return null;
            } else {
                log.sendLog(date, getFuncMod(type), 'ERROR', "NEW_QUOTATION_FAILED_NO_RESPONSE", [{ salesVariant: salesVariant, scenarioCode: scenarioCode }], error.response);
                throw error;
            }
        });
    data.salesVariant = salesVariant;
    return data;
}

export async function saveQuotation(quotation: Quotation, type: ProductType) {
    let resp: Response;
    const date = new Date();
    const params = await getGA
    await axios.post<Quotation>(`${config.API_URL}/${getTypePath(type)}/quotation?user_id=${params.user_id}&session_id=${params.session_id}&client_id=${params.client_id}${getUtmMarks(true)}`, quotation, axiosConfig)
        .then((response) => {
            log.sendLog(date, getFuncMod(type), 'INFO', "SAVE_QUOTATION", [{ quotation: quotation, response: response.data }], '');
            resp = {
                success: true,
                data: response.data,
            };
        })
        .catch((err) => {
            log.sendLog(date, getFuncMod(type), 'ERROR', "SAVE_QUOTATION_FAILED_NO_RESPONSE", [{ quotation: quotation }], err.response);

            resp = {
                success: false,
                errorResponse: getErrorResponse(err),
            };
        });

    return resp;
}

export const logSuccessfulQuotation = (id:string, type:ProductType) => {
    axios.post(`${config.API_URL}/${getTypePath(type)}/log/${id}`)
}

export async function calculate(quotation: Quotation | TravelQuotation, type: ProductType) {
    const date = new Date();
    let resp: Response;
    const params = await getGA
    await axios.post<QuoationPackage[] | TravelQuotationPackage[]>(`${config.API_URL}/${getTypePath(type)}/calculate?user_id=${params.user_id}&session_id=${params.session_id}&client_id=${params.client_id}`, quotation, axiosConfig)
        .then((response) => {
            log.sendLog(date, getFuncMod(type), 'INFO', "CALCULATE", [{ quotation: quotation, response: response.data }], '');
            resp = {
                success: true,
                data: response.data,
            };
        })
        .catch((err) => {
            log.sendLog(date, getFuncMod(type), 'ERROR', "CALCULATE_FAILED_NO_RESPONSE", [{ quotation: quotation }], err.response);
            resp = {
                success: false,
                errorResponse: getErrorResponse(err),
            };
        });

    return resp;
}

export async function sendToEmail(quotationId: string, email: string, type: ProductType) {
    const { data } = await axios.post(`${config.API_URL}/${getTypePath(type)}/send-to-email?quotationId=${quotationId}&email=${email}`, {}, axiosConfig);
    return data;
}

function getErrorResponse(err: any) {

    let errorResponse = {
        status: "000",
        text: "Невiдома помилка",
        detailText: "порожньо..."
    } as ErrorResponse;

    let errorTextJSON = JSON.stringify(err)
    console.error("err.errorTextJSON:" + errorTextJSON);
    console.error("err.err.response:" + err.response);
    errorResponse.redirectUrl = err.response.data.redirectUrl;

    if (err.message === "Network Error" || err.message === "Request failed with status code 500") {
        errorResponse.status = "500";
        errorResponse.text = "Помилки з'єднання";
        if (err.response) {
            errorResponse.detailText = err.response.data.toString()
        } else if (err.data) {
            errorResponse.detailText = err.data;
        } else {
            errorResponse.detailText = JSON.stringify(err);
        }

        return errorResponse;
    }

    errorResponse.detailText = err.toString();

    if (err.response) {
        console.error("err.response:" + err.response);
        errorResponse.text = err.toString();
        errorResponse.detailText = err.response.data.toString();
        if (err.response.data.errorMessage) {
            let textErr = err.response.data.errorMessage;
            let errorPoint = textErr.search("Error: ");
            errorResponse.text = errorPoint > 0 ? textErr.slice(errorPoint + 7) : textErr;
            errorResponse.detailText = textErr;
        }
    }

    return errorResponse;
}
